import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
import {
    formatterTime
} from '@/util/util'

export const redPacketDetailsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
        label: "领取人姓名",
        prop: "realName",
        search:true,
        type: 'input'
    },
        {
            label: "金额",
            prop: "quota",
            type: "input",
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true
        },
        {
            label: "领取时间",
            prop: "collectionTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "领取时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            search: true,
            hide: true,
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },


    ]
};